(function() {
	'use strict'

	angular
		.module( "ATMGurus" )
		.directive( "navTritonmanualMenu", [
			"ApiQuery",
			"$rootScope",
			"$http",
			"$sce",
			function( ApiQuery, $rootScope, $http, $sce ) {

				// ddo
				return {
					restrict: "AE",
					link: function( scope, element, attrs ) {

						// root element
						var nav = $( "<ul class='menu menu-bare menu-vertical'>" );
						element.append( nav )

						// fetch data and build structure
						fetchData( function( response ) {
							attachSubMenu( nav, response )

							_.forEach( element.find( "a" ), function( link ) {
								angular.element( link ).on( "click", function( e ) {
									e.preventDefault();
									scope.getContent( $( this ).attr( "href" ) )
								} )
							} )
						});


						/*
						*	fetch actual page content
						*/
						scope.getContent = function( page ) {
							// page is prepended with the relative path
							var staticUrlPart = "/manual/3.2/";

							var params = {
								page: page.slice( staticUrlPart.length ).replace( /_+/gi, " ")
							}

							ApiQuery( "manuals/content", params, "POST")
								.then( function( response ) {
									var content = $( "<div>" ).append( $.parseHTML( decodeURIComponent( response.data.content ) ) )
									scope.content = content.prop( "outerHTML" )
								})
						}

						scope.trust = function( html ) {
							return $sce.trustAsHtml( html )
						}

					}
				}

				/*
				*	fetch navmenu elements
				*/
				function fetchData( cb ) {
					ApiQuery( "manuals", "", "GET" )
						.then( function( response ) {
							if ( response.success ) {
								cb( response.menu )
							}
							else {
								$rootScope.$broadcast( "modal.open", { title: 'Error!', template: 'error', data: { message: "Unable to provide requested content." }})
							}
						} )
						.catch( function( error ) {
							$rootScope.$broadcast( "modal.open", { title: 'Error!', template: 'error', data: { message: error.message }})
						})
					}

				/**
				*	build hierarchic structure
				*/
				function attachSubMenu( parent, items ) {

					_.forEach( items, function( item ) {

						var RegEx = new RegExp( " ", "g" );
						var a = $("<a class='menu-link'>")
							.text( item.name )
							.attr( { href: "/manual/3.2/" + item.name.replace( RegEx, "_" ) } )

						var child = $( "<li class='menu-item'>")
						child.append( a )
						parent.append( child )

						if ( item.children ) {
							var sub = $( "<ul class=''>" );
							child.append( sub )
							attachSubMenu( sub, item.children )
						}
					})
				}
			}
		])
})()


// WEBPACK FOOTER //
// ./src/app/directives/nav-tritonmanual-menu.js